import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import './App.css'
import Login from './app/pages/login/Login'
import ForgotPassword from './app/pages/forgot-password/ForgotPassword'

function App() {
  return (
    <BrowserRouter>
      {/* <GAListener trackingId={process.env.REACT_APP_GA_CODE}> */}
      <Switch>
        <Route exact path='/forgot-password' component={ForgotPassword} />
        <Route path='/' component={Login} />
      </Switch>
      {/* </GAListener> */}
    </BrowserRouter>
  )
}

export default App
